export default "__VITE_ASSET__Cl9q4LSk__";